export const privacyMap = [
    {
        value: 0,
        label: 'Everyone'
    },
    {
        value: 1,
        label: 'Community'
    },
    {
        value: 2,
        label: 'Event'
    },
    {
        value: 3,
        label: 'Division'
    },
    {
        value: 4,
        label: 'Me'
    }
]

export const divisionMap = [
    {
        value: 'All',
        label: 'All'
    },
    {
        value: 'FTJ',
        label: 'FTJ'
    },
    {
        value: 'HAZON',
        label: 'HAZON'
    },
    {
        value: 'HOL',
        label: 'HOL'
    },
    {
        value: 'Wellspring',
        label: 'Wellspring'
    },
    {
        value: 'SHIHR',
        label: 'SHIHR'
    },
]


export const statusMap = [
    {
        value: 'Draft',
        label: 'Draft'
    },
    {
        value: 'Active',
        label: 'Active'
    },
    {
        value: 'InActive',
        label: 'InActive'
    },
    {
        value: 'Archived',
        label: 'Archived'
    },
]

export const ContentMap = [
    'file',
    'sefaria_link',
    'hartman_link',
    'external_link',
    'recording_session'
]

export const ContentTypesUi = [
    {
        id: 1,
        label: 'File',
        icon: 'mdi mdi-file',
        color: 'white',
        bg: 'primary',
        isActive: true
    },
    {
        id: 2,
        label: 'Sefaria Link',
        icon: 'mdi mdi-library-shelves',
        color: 'white',
        bg: 'primary',
        isActive: false
    },
    {
        id: 3,
        label: 'Hartman Link',
        icon: 'mdi mdi-library',
        color: 'white',
        bg: 'primary',
        isActive: false
    },
    {
        id: 4,
        label: 'External Link',
        icon: 'mdi mdi-link',
        color: 'white',
        bg: 'primary',
        isActive: false
    },
    // {
    //     id: 5,
    //     label: 'Recording Session',
    //     icon: 'mdi mdi-filmstrip',
    //     color: 'white',
    //     bg: 'primary',
    //     isActive: false
    // }
]

export const REGEX_CONSTANTS = {
    /* eslint-disable */
    link: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
}

export const msFileTypes = [
    ".png",
    ".jpeg",
    ".jpg",
    ".gif",
    ".txt",
    ".doc",
    ".dot",
    ".docx",
    ".dotx",
    ".docm",
    ".dotm",
    ".xls",
    ".xlt",
    ".xla",
    ".xlsx",
    ".xltx",
    ".xlsm",
    ".mdb",
    ".xltm",
    ".xlam",
    ".xlsb",
    ".ppt",
    ".pot",
    ".pps",
    ".ppa",
    ".pptx",
    ".potx",
    ".ppsx",
    ".ppam",
    ".pptm",
    ".potm",
    ".ppsm",
    ".pdf"
]

export const inputFileTypes = msFileTypes.map(m => ({
    value: m.substr(1),
    label: m.substr(1)
}))